import React from 'react';
import {Icon} from 'antd';

import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';
import ContractActionIcon from './contract-action-icon';


const filterItems = [
    {
        id: 'cabinet',
        number: 1,
        content: (
            <>
                Перейдите в раздел <strong>«Кабинет»</strong>.
            </>
        ),
        area: {
            top: 0.6,
            left: 50.8,
            width: 6,
            height: 5
        }
    },
    {
        id: 'partners',
        number: 2,
        content: (
            <>
                Откройте вкладку <strong>«Перевозчики»</strong>.
            </>
        ),
        area: {
            top: 85,
            left: 3,
            width: 22,
            height: 6
        }
    },
    {
        id: 'view-mode',
        number: 3,
        content: (
            <>
                Выберите режим просмотра: все контрагенты,
                ожидающие согласования или договоры на согласовании.
            </>
        ),
        area: {
            top: 35.1,
            left: 25.7,
            width: 69.5,
            height: 5
        }
    },
    {
        id: 'main-filters',
        number: 4,
        content: (
            <>
                Укажите организацию, распределительный центр,
                статус договора и статус согласования.
            </>
        ),
        area: {
            top: 41.7,
            left: 25.7,
            width: 69.5,
            height: 19
        }
    },
    {
        id: 'counterparty-search',
        number: 5,
        content: (
            <>
                Найдите контрагента по логину, ИНН,
                названию или WebID.
            </>
        ),
        area: {
            top: 61,
            left: 25.7,
            width: 69.5,
            height: 21
        }
    },
    {
        id: 'additional-filters',
        number: 6,
        content: (
            <>
                При необходимости укажите дополнительные условия
                и нажмите кнопку <strong>«Применить»</strong>.
            </>
        ),
        area: {
            top: 81,
            left: 25.7,
            width: 69.5,
            height: 19
        }
    }
];


const counterpartyInfoItems = [
    {
        id: 'counterparty-data',
        number: 1,
        content: (
            <>
                Проверьте WebID, ID юридического лица
                и регистрационные сведения контрагента.
            </>
        ),
        area: {
            top: 1,
            left: 0.5,
            width: 26,
            height: 63
        }
    },
    {
        id: 'counterparty-manager',
        number: 2,
        content: (
            <>
                Проверьте ответственного сотрудника
                и актуальный логин.
            </>
        ),
        area: {
            top: 34,
            left: 37.2,
            width: 24.5,
            height: 30
        }
    },
    {
        id: 'counterparty-status',
        number: 3,
        content: (
            <>
                Проверьте текущий статус согласования.
            </>
        ),
        area: {
            top: 4.27,
            left: 74.24,
            width: 23.16,
            height: 12.88
        }
    }
];


const counterpartyDecisionItems = [
    {
        id: 'approve-logist',
        number: 1,
        content: (
            <>
                Для обычного согласования нажмите
                <strong> «Согласовать Логист»</strong>.
            </>
        ),
        area: {
            top: 58.49,
            left: 74.35,
            width: 23.04,
            height: 11.57
        }
    },
    {
        id: 'approve-personally',
        number: 2,
        content: (
            <>
                При необходимости выберите
                <strong> «Согласовать под личную ответственность»</strong>.
            </>
        ),
        area: {
            top: 70.85,
            left: 74.24,
            width: 23.16,
            height: 10.78
        }
    },
    {
        id: 'decline-counterparty',
        number: 3,
        content: (
            <>
                Если в данных обнаружена ошибка, нажмите
                <strong> «Отклонить»</strong>.
            </>
        ),
        area: {
            top: 83.46,
            left: 74.24,
            width: 23.16,
            height: 11.3
        }
    }
];


const approvalDialogItems = [
    {
        id: 'company-type',
        number: 1,
        content: (
            <>
                Проверьте указанный тип компании.
            </>
        ),
        area: {
            top: 6,
            left: 37.5,
            width: 25,
            height: 8
        }
    },
    {
        id: 'approval-documents',
        number: 2,
        content: (
            <>
                Проверьте дополнительные документы
                и снимки из АТИ.
            </>
        ),
        area: {
            top: 20,
            left: 7,
            width: 85,
            height: 61
        }
    },
    {
        id: 'approve-counterparty',
        number: 3,
        content: (
            <>
                После проверки нажмите кнопку
                <strong> «Согласовать»</strong>.
            </>
        ),
        area: {
            top: 88.72,
            left: 41.43,
            width: 17.14,
            height: 5.32
        }
    }
];


const approvedInfoItems = [
    {
        id: 'approved-data',
        number: 1,
        content: (
            <>
                Проверьте идентификаторы и регистрационные
                сведения контрагента.
            </>
        ),
        area: {
            top: 1,
            left: 0.5,
            width: 26,
            height: 71
        }
    },
    {
        id: 'approved-manager',
        number: 2,
        content: (
            <>
                Проверьте ответственного сотрудника
                и актуальный логин.
            </>
        ),
        area: {
            top: 33,
            left: 37.5,
            width: 24,
            height: 32
        }
    },
    {
        id: 'approved-status',
        number: 3,
        content: (
            <>
                Убедитесь, что контрагенту присвоен статус
                <strong> «Подтверждено»</strong>.
            </>
        ),
        area: {
            top: 5.04,
            left: 74.12,
            width: 23.27,
            height: 14.25
        }
    }
];


const companyManagementItems = [
    {
        id: 'change-company-data',
        number: 4,
        content: (
            <>
                Чтобы исправить реквизиты или другие сведения,
                нажмите <strong>«Изменить данные»</strong>.
            </>
        ),
        area: {
            top: 53.74,
            left: 37.69,
            width: 23.5,
            height: 10.69
        }
    },
    {
        id: 'company-settings',
        number: 5,
        content: (
            <>
                Для управления компанией откройте
                <strong> «Настройки»</strong>.
            </>
        ),
        area: {
            top: 66.8,
            left: 74.24,
            width: 23.04,
            height: 12.47
        }
    },
    {
        id: 'legal-entity-data',
        number: 6,
        content: (
            <>
                В разделе <strong>«Данные юр. лица»</strong>{' '}
                можно проверить сведения и загруженные документы.
            </>
        ),
        area: {
            top: 81.05,
            left: 1.82,
            width: 19.86,
            height: 12.47
        }
    },
    {
        id: 'company-employees',
        number: 7,
        content: (
            <>
                В разделе <strong>«Сотрудники»</strong>{' '}
                можно проверить сотрудников компании и их логины.
            </>
        ),
        area: {
            top: 81.35,
            left: 74.24,
            width: 22.93,
            height: 12.17
        }
    }
];


const approvedCounterpartyItems = [
    ...approvedInfoItems,
    ...companyManagementItems
];


const contractListItems = [
    {
        id: 'contract-data',
        number: 1,
        content: (
            <>
                Проверьте организацию, распределительный центр
                и вид договора.
            </>
        ),
        area: {
            top: 40.5,
            left: 0.5,
            width: 40,
            height: 50
        }
    },
    {
        id: 'contract-status',
        number: 2,
        content: (
            <>
                Проверьте текущий статус договора.
            </>
        ),
        area: {
            top: 40.5,
            left: 40.47,
            width: 21.5,
            height: 50
        }
    },
    {
        id: 'contract-actions',
        number: 3,
        content: (
            <>
                Проверьте дату подачи и доступные действия.
            </>
        ),
        area: {
            top: 40.5,
            left: 61.5,
            width: 30,
            height: 50
        }
    },
    {
        id: 'new-contracts',
        number: 4,
        content: (
            <>
                Оранжевый счётчик показывает количество
                новых договоров, ожидающих проверки.
            </>
        ),
        area: {
            top: 93,
            left: 46.5,
            width: 9.5,
            height: 6.5
        }
    }
];


const counterpartyStatuses = [
    {
        label: 'На согласовании',
        tone: 'pending',
        text:
            'Документы и сведения контрагента ещё проверяются ответственными службами.'
    },
    {
        label: 'Подтверждено',
        tone: 'success',
        text:
            'Контрагент успешно прошёл необходимые этапы согласования.'
    },
    {
        label: 'Отклонено',
        tone: 'danger',
        text:
            'В данных или документах обнаружена ошибка, которую необходимо исправить.'
    }
];


const contractStatuses = [
    {
        label: 'Ожидает скан подписанного договора',
        tone: 'waiting',
        text:
            'Контрагент подал заявку на выбранный РЦ, но ещё не приложил подписанный договор.'
    },
    {
        label: 'На согласовании',
        tone: 'pending',
        text:
            'Подписанный договор ожидает проверки и решения логиста.'
    },
    {
        label: 'Отклонено',
        tone: 'danger',
        text:
            'В договоре обнаружена ошибка, а контрагенту отправлена причина отклонения.'
    },
    {
        label: 'Подтверждено',
        tone: 'success',
        text:
            'Договор проверен и согласован. Контрагент сможет скачать экземпляр с подписью и печатью.'
    }
];


const contractActions = [
    {
        icon: 'download',
        label: 'Скачать документы',
        text:
            'Скачайте документы и проверьте подписанные перевозчиком экземпляры.'
    },
    {
        icon: 'approve',
        label: 'Согласовать договор',
        text:
            'Если договор оформлен без ошибок, согласуйте его. После согласования перевозчик сможет направлять встречные предложения по рейсам.'
    },
    {
        icon: 'decline',
        label: 'Отклонить договор',
        text:
            'Если в договоре есть ошибка, отклоните его и обязательно укажите причину. Сообщение будет отправлено перевозчику для исправления.'
    },
    {
        icon: 'reason',
        label: 'Посмотреть причину отказа',
        text:
            'Откройте причину отказа, чтобы посмотреть комментарий и историю согласования договора.'
    },
    {
        icon: 'rollback',
        label: 'Расторгнуть договор',
        text:
            'Если договор необходимо перезаключить, отправьте запрос на расторжение. После подтверждения директором по логистике договор будет расторгнут.'
    }
];


function StatusGrid({items}) {
    return (
        <div className="instruction-status-grid">
            {items.map((item) => (
                <div
                    className={`instruction-status-card instruction-status-card--${item.tone}`}
                    key={item.label}
                >
                    <strong className="instruction-status-card__badge">
                        {item.label}
                    </strong>

                    <p className="instruction-status-card__text">
                        {item.text}
                    </p>
                </div>
            ))}
        </div>
    );
}


export default function PartnersInstruction() {
    return (
        <InstructionLayout title="Согласование перевозчиков и договоров">
            <div className="service-highlight">
                            <span className="service-highlight__icon">
                                <Icon type="warning"/>
                            </span>

                            <div>
                                <strong className="service-highlight__title">
                                    Внимание
                                </strong>

                                <p className="service-highlight__text">
                                    В данный момент на скриншотах указано старое
                                    наименование раздела «Партнеры».
                                    Вскоре инструкция будет обновлена.
                                </p>
                            </div>
                        </div>

            <p className="instruction-intro">
                В разделе «Перевозчики» логист может найти контрагента,
                проверить его данные и документы, выполнить согласование,
                а затем проверить и согласовать договор.
            </p>

            <div className="service-highlight">
                <span className="service-highlight__icon">
                    <Icon type="environment"/>
                </span>

                <div>
                    <strong className="service-highlight__title">
                        Доступные контрагенты
                    </strong>

                    <p className="service-highlight__text">
                        В разделе отображаются только контрагенты
                        и договоры по подключённым вам
                        распределительным центрам.
                    </p>
                </div>
            </div>

            <InstructionStep
                number={1}
                title="Найдите нужного контрагента"
            >
                <div className="instruction-copy">
                    <p>
                        Откройте раздел «Перевозчики» и используйте
                        фильтры для поиска нужного контрагента.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/partners/01-partner-filters.png"
                    alt="Фильтры и поиск в разделе «Перевозчики»"
                    items={filterItems}
                    layout="grid"
                />
            </InstructionStep>

            <InstructionStep
                number={2}
                title="Проверьте карточку контрагента"
            >
                <div className="instruction-copy">
                    <p>
                        Перед согласованием проверьте идентификаторы,
                        регистрационные сведения, ответственного сотрудника
                        и текущий статус заявки.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/partners/02-counterparty-review.png"
                    alt="Карточка контрагента на согласовании"
                    items={counterpartyInfoItems}
                    layout="grid"
                />

                <section className="service-section service-section--spaced">
                    <h2 className="service-section__title">
                        Статусы согласования
                    </h2>

                    <StatusGrid items={counterpartyStatuses}/>
                </section>
            </InstructionStep>

            <InstructionStep
                number={3}
                title="Согласуйте или отклоните контрагента"
            >
                <div className="instruction-copy">
                    <p>
                        После проверки выберите необходимое действие
                        в карточке контрагента.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/partners/02-counterparty-review.png"
                    alt="Действия согласования контрагента"
                    items={counterpartyDecisionItems}
                    layout="grid"
                />

                <InstructionSpotlight
                    src="/img/instructions/partners/03-approval-dialog.png"
                    alt="Форма согласования юридического лица"
                    items={approvalDialogItems}
                    layout="grid"
                />

                <div className="service-section__media">
                    <div className="service-note">
                        <Icon
                            className="service-note__icon"
                            type="info-circle"
                        />

                        <p className="service-note__text">
                            Если обнаружена ошибка, отклоните заявку
                            и обязательно укажите причину. Комментарий
                            сохранится в истории согласования и будет
                            отправлен контрагенту для исправления.
                        </p>
                    </div>
                </div>
            </InstructionStep>

            <InstructionStep
                number={4}
                title="Работайте с согласованным контрагентом"
            >
                <div className="instruction-copy">
                    <p>
                        После успешной проверки статус карточки изменится
                        на «Подтверждено». В карточке останутся доступны
                        сведения о компании и действия по управлению.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/partners/04-approved-counterparty.png"
                    alt="Сведения и управление согласованным контрагентом"
                    items={approvedCounterpartyItems}
                    layout="grid"
                />

                <div className="service-section__media">
                    <div className="service-note">
                        <Icon
                            className="service-note__icon"
                            type="info-circle"
                        />

                        <p className="service-note__text">
                            Изменение логина сотрудника или реквизитов
                            юридического лица вступит в силу после
                            согласования директором по логистике.
                        </p>
                    </div>
                </div>
            </InstructionStep>

            <InstructionStep
                number={5}
                title="Проверьте и согласуйте договор"
            >
                <div className="instruction-copy">
                    <p>
                        После полного согласования контрагента
                        перейдите к проверке и заключению договоров.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/partners/05-contracts.png"
                    alt="Список договоров контрагента"
                    items={contractListItems}
                    layout="grid"
                />

                <section className="service-section service-section--spaced">
                    <h2 className="service-section__title">
                        Статусы договоров
                    </h2>

                    <StatusGrid items={contractStatuses}/>
                </section>

                <section className="service-section service-section--spaced">
                    <h2 className="service-section__title">
                        Действия логиста
                    </h2>

                    <p className="service-section__description">
                        Набор доступных кнопок зависит от текущего
                        статуса договора и прав пользователя.
                    </p>

                    <div className="contract-action-list">
                        {contractActions.map((action, index) => (
                            <div
                                className="contract-action-list__item"
                                key={action.icon}
                            >
                                <span className="service-checklist__number">
                                    {index + 1}
                                </span>

                                <p className="contract-action-list__text">
                                    {action.text}
                                </p>

                                <span
                                    className="contract-action-list__button"
                                    title={action.label}
                                >
                                    <ContractActionIcon
                                        type={action.icon}
                                    />
                                </span>
                            </div>
                        ))}
                    </div>
                </section>
            </InstructionStep>
        </InstructionLayout>
    );
}